export default __webpack_public_path__ + "static/cat-78e12baeffa564b59bac87c168accf6e.png";